import { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { os } from "../platform";
import { WebView } from "react-native-webview";
 
const WebViewScreen = ({ route }) => {
  const { url } = route.params;
  const insets = useSafeAreaInsets();
 
  useEffect(() => {
    // Suppress a warning on iOS regarding srcdoc, which is not relevant to our usage of WebView
    const originalWarn = console.warn;
    console.warn = () => {};
 
    return () => {
      console.warn = originalWarn;
    };
  }, []);
 
  return (
    <View style={styles.container} testID="webview-screen-container">
      <WebView
        testID="webview-component"
        source={{ uri: url }}
        style={
          os === "android" && (url.includes("vbgo") || url.includes("vbparkfinder")) ? { marginTop: -insets.top } : {}
        }
        startInLoadingState
        javaScriptEnabled
        domStorageEnabled
      />
    </View>
  );
};
 
const styles = StyleSheet.create({
  container: { flex: 1 },
});
 
export default WebViewScreen;
 
 